import React, { useState, useRef } from 'react';
import { Box, Button, TextField, Typography, Dialog, CircularProgress } from '@mui/material';
import useApiManager from '../../utils/Api/apiManager';

const ImportData = () => {
    const { post } = useApiManager();

    const [attachment1, setAttachment1] = useState(null); // accounts
    const [attachment2, setAttachment2] = useState(null); // leads
    const [attachment3, setAttachment3] = useState(null); // contacts
    const [attachment4, setAttachment4] = useState(null); // lead notes
    const [attachment5, setAttachment5] = useState(null); // contact notes
    const [attachment6, setAttachment6] = useState(null); // account notes
    const [attachment7, setAttachment7] = useState(null); // tasks
    const [attachment8, setAttachment8] = useState(null); // campaigns
    const [attachment9, setAttachment9] = useState(null); // deals

    // Loading state for the modal
    const [isUploading, setIsUploading] = useState(false);

    const lastFileInputRef = useRef(null); // Ref for the last file input

    const handleFileChange = (e, setAttachment) => {
        const { files } = e.target;
        setAttachment(files[0]);
        lastFileInputRef.current = e.target;  // Update the ref to point to the current file input
    };

    const uploadFile = async (file, endpoint, setAttachment) => {
        setIsUploading(true); // Show modal

        const formData = new FormData();
        formData.append('file', file);

        try {
            const response = await post(endpoint, formData, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                },
                timeout: 300000, // 5 minutes timeout
            });
            alert(`File uploaded successfully to ${endpoint}!`);
            console.log(response.data);
            setAttachment(null);
            if (lastFileInputRef.current) {
                lastFileInputRef.current.value = ''; // Clear the file input
            }
        } catch (error) {
            console.error(`Error uploading file to ${endpoint}:`, error);
            alert(`Failed to upload file to ${endpoint}.`);
        } finally {
            setIsUploading(false); // Hide modal
        }
    };

    return (
        <Box sx={{ padding: '20px', maxWidth: '500px', margin: '0 auto' }}>
            <Typography variant="h4" component="h1" gutterBottom>
                Import Data
            </Typography>

            <Box sx={{ marginBottom: '16px' }}>
                <Typography variant="body1" gutterBottom>
                    Accounts:
                </Typography>
                <TextField
                    type="file"
                    onChange={(e) => handleFileChange(e, setAttachment1)}
                    fullWidth
                    InputLabelProps={{ shrink: true }}
                />
                <Button
                    sx={{ marginTop: '8px' }}
                    variant="contained"
                    color="primary"
                    onClick={() => attachment1 && uploadFile(attachment1, '/accounts/import', setAttachment1)}
                >
                    Import
                </Button>
            </Box>

            <Box sx={{ marginBottom: '16px' }}>
                <Typography variant="body1" gutterBottom>
                    Leads:
                </Typography>
                <TextField
                    type="file"
                    onChange={(e) => handleFileChange(e, setAttachment2)}
                    fullWidth
                    InputLabelProps={{ shrink: true }}
                />
                <Button
                    sx={{ marginTop: '8px' }}
                    variant="contained"
                    color="primary"
                    onClick={() => attachment2 && uploadFile(attachment2, '/leads/import-leads', setAttachment2)}
                >
                    Import
                </Button>
            </Box>

            <Box sx={{ marginBottom: '16px' }}>
                <Typography variant="body1" gutterBottom>
                    Contacts:
                </Typography>
                <TextField
                    type="file"
                    onChange={(e) => handleFileChange(e, setAttachment3)}
                    fullWidth
                    InputLabelProps={{ shrink: true }}
                />
                <Button
                    sx={{ marginTop: '8px' }}
                    variant="contained"
                    color="primary"
                    onClick={() => attachment3 && uploadFile(attachment3, '/leads/import-contacts', setAttachment3)}
                >
                    Import
                </Button>
            </Box>
            <Typography variant="h5" component="h1" gutterBottom>
                Notes
            </Typography>
            <Box sx={{ marginBottom: '16px' }}>
                <Typography variant="body1" gutterBottom>
                    Lead Notes:
                </Typography>
                <TextField
                    type="file"
                    onChange={(e) => handleFileChange(e, setAttachment4)}
                    fullWidth
                    InputLabelProps={{ shrink: true }}
                />
                <Button
                    sx={{ marginTop: '8px' }}
                    variant="contained"
                    color="primary"
                    onClick={() => attachment4 && uploadFile(attachment4, '/leads/import-lead-notes', setAttachment4)}
                >
                    Import
                </Button>
            </Box>
            <Box sx={{ marginBottom: '16px' }}>
                <Typography variant="body1" gutterBottom>
                    Contact Notes:
                </Typography>
                <TextField
                    type="file"
                    onChange={(e) => handleFileChange(e, setAttachment5)}
                    fullWidth
                    InputLabelProps={{ shrink: true }}
                />
                <Button
                    sx={{ marginTop: '8px' }}
                    variant="contained"
                    color="primary"
                    onClick={() => attachment5 && uploadFile(attachment5, '/leads/import-contact-notes', setAttachment5)}
                >
                    Import
                </Button>
            </Box>
            <Box sx={{ marginBottom: '16px' }}>
                <Typography variant="body1" gutterBottom>
                    Account Notes:
                </Typography>
                <TextField
                    type="file"
                    onChange={(e) => handleFileChange(e, setAttachment6)}
                    fullWidth
                    InputLabelProps={{ shrink: true }}
                />
                <Button
                    sx={{ marginTop: '8px' }}
                    variant="contained"
                    color="primary"
                    onClick={() => attachment6 && uploadFile(attachment6, '/accounts/import-notes', setAttachment6)}
                >
                    Import
                </Button>
            </Box>
            <Typography variant="h5" component="h1" gutterBottom>
                Tasks
            </Typography>
            <Box sx={{ marginBottom: '16px' }}>
                <Typography variant="body1" gutterBottom>
                    Tasks:
                </Typography>
                <TextField
                    type="file"
                    onChange={(e) => handleFileChange(e, setAttachment7)}
                    fullWidth
                    InputLabelProps={{ shrink: true }}
                />
                <Button
                    sx={{ marginTop: '8px' }}
                    variant="contained"
                    color="primary"
                    onClick={() => attachment7 && uploadFile(attachment7, '/tasks/import-tasks', setAttachment7)}
                >
                    Import
                </Button>
            </Box>
            <Typography variant="h5" component="h1" gutterBottom>
                Campaigns
            </Typography>
            <Box sx={{ marginBottom: '16px' }}>
                <Typography variant="body1" gutterBottom>
                    Campaigns:
                </Typography>
                <TextField
                    type="file"
                    onChange={(e) => handleFileChange(e, setAttachment8)}
                    fullWidth
                    InputLabelProps={{ shrink: true }}
                />
                <Button
                    sx={{ marginTop: '8px' }}
                    variant="contained"
                    color="primary"
                    onClick={() => attachment8 && uploadFile(attachment8, '/campaigns/import', setAttachment8)}
                >
                    Import
                </Button>
            </Box>
            <Typography variant="h5" component="h1" gutterBottom>
                Deals
            </Typography>
            <Box sx={{ marginBottom: '16px' }}>
                <Typography variant="body1" gutterBottom>
                    Deals:
                </Typography>
                <TextField
                    type="file"
                    onChange={(e) => handleFileChange(e, setAttachment9)}
                    fullWidth
                    InputLabelProps={{ shrink: true }}
                />
                <Button
                    sx={{ marginTop: '8px' }}
                    variant="contained"
                    color="primary"
                    onClick={() => attachment9 && uploadFile(attachment9, '/deals/import', setAttachment9)}
                >
                    Import
                </Button>
            </Box>
            {/* Loading Modal */}
            <Dialog open={isUploading}>
                <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', p: 3 }}>
                    <CircularProgress />
                    <Typography sx={{ mt: 2 }}>Uploading, please wait...</Typography>
                </Box>
            </Dialog>
        </Box>
    );
};

export default ImportData;
